<div class="container pl-5 pr-5" style="padding-top: 140px">
  <app-breadcrumb category="My Account"></app-breadcrumb>
  <div style="height: 24px"></div>
  <div class="row">
    <div class="col-lg-3">
      <div class="container-1">
        <h5 style="font-family: 'proxima-nova'; font-size: 24px;">my account</h5>
        <li>Account Information</li>
        <br />
        <a routerLink="/myorders"> My Orders</a> <br />
        <a (click)="logout()">Logout</a><br /><br />
      </div>
    </div>

    <div class="col-lg-9">
      <h5 style="font-family: 'proxima-nova'; font-size: 24px;">Hello,</h5>

      <br />
      <small class="text-muted">
        From your dashboard you have the ability to view a snapshot of your
        recent account activity and update your account information. Select a
        link below to view or edit information. </small
      ><br />
      <br />
      <div style="width: 50%">
        <h5>Account Information</h5>

        <hr style="height: 0.3px" />

        <h2 class="float-left"><b>Contact Information</b></h2>
        <br />
        <br />
        <p>Name:   {{ user.name }}</p>
        <div class="d-flex justify-content-between">
          <p>Contact no:   <br>9876543210</p>
          <small class="float-right"><a href="editprofile">Edit</a></small>
        </div>
        <p>Email:  {{ user.mail }}</p>
        <br />
        <br />
      </div>
      <div style="width: 50%">
        <h5>Address book</h5>
        <hr style="height: 0.5px;"/>
      </div>
      <br />
      <a href="manageaddress">Manage Addresses</a>
    </div>
  </div>
</div>
